/* eslint-disable complexity */
import { ProjectFormState } from 'src/core/models'

const isDefinitionCompleted = (form: ProjectFormState): boolean => {
  return Boolean(form.kind)
}

const isLocationCompleted = (form: ProjectFormState): boolean => {
  return ![form.latitude, form.longitude, form.country].includes(null)
}

const isContentCompelted = (form: ProjectFormState): boolean => {
  if (![
    form.name, form.url,
    form.registered_since, form.main_image, form[`description_en`]
  ].some(o => !o || o === '')) { return true }
  return false
}

const isPriceCompleted = (form: ProjectFormState): boolean => {
  if (form.kind === 'contribution') {
    if (form.contributionProjectType === 'FREE_DONATION' && form.currency_token) {
      return true
    } else if (form.contributionProjectType === 'CONTRIBUTION_UNIT') {
      if (![form.contribution_unit, form.volume_credits, form.price, form.currency_token].includes(null)) {
        return true
      }
    }
  } else {
    if (!form.is_vintage) {
      if (![form.volume_credits, form.price, form.currency_token].includes(null)) {
        return true
      }
    } else {
      if (form.currency_token && form.vintage_items.length > 0) {
        return true
      }
    }
  }
  return false
}


const isCertificationsCompleted = (form: ProjectFormState): boolean => {
  if (form.kind === 'compensation') {
    if (![
      form.status, form.type, form.sub_type, form.methodology, form.mechanism,
      form.validator, form.first_verifier, form.standard, form.credit_start, form.credit_end
    ].some(o => !o || o === '')) {
      return true
    }
  }
  if (form.kind === 'energy') {
    if (![
      form.status, form.energy_type, form.central_name,
      form.standard_energy_type, form.validator, form.first_verifier
    ].some(o => !o || o === '')) {
      return true
    }
  }
  if (form.kind === 'biodiversity') {
    if (![
      form.status, form.type_of_biome_ecosystem, form.methodology,
      form.validator, form.credit_start, form.credit_end
    ].some(o => !o || o === '')) {
      return true
    }
  }
  if (form.kind === 'carbon_forward') {
    if (![
      form.stage, form.type, form.sub_type,
      form.methodology, form.mechanism, form.validator,
      form.first_verifier, form.standard, form.complementary_standards,
      form.credit_start, form.credit_end
    ].some(o => !o || o === '')) {
      return true
    }
  }
  return false
}

const isDocumentationCompleted = (form: ProjectFormState): boolean => {
  if (form.kind === 'compensation' && ![
    form.registry_depositing_id,
    form.registry_depositing_name,
    form.registry_depositing_url,
    form.credits_certificate
  ].includes(null)) {
    return true
  } else if (form.kind === 'energy' && ![
    form.registry_depositing_id,
    form.registry_depositing_name,
    form.registry_depositing_url,
    form.device_registration_request,
    form.start_up_date_of_installation,
    form.resulting_from_the_issuer
  ].includes(null)) {
    return true
  } else if (form.kind === 'biodiversity' && ![
    form.registry_depositing_id,
    form.registry_depositing_name,
    form.registry_depositing_url,
    form.credits_certificate,
    form.protocol_implementation_scheme,
    form.executive_summary,
    form.additional_documentation,
    form.monitoring_report,
  ].includes(null)) {
    return true
  }
  else if (form.kind === 'carbon_forward' && ![
    form.credits_certificate,
  ].includes(null)) {
    return true
  }
  return false
}

const isTaxReliefCompleted = (form: ProjectFormState): boolean => {
  if (form.kind !== 'contribution') return false
  if (!form.is_tax_relief) return false
  return !(
    !form.tax_info_en &&
    !form.tax_info_es &&
    !form.tax_info_fr &&
    !form.tax_info_ko &&
    !form.tax_info_de &&
    !form.tax_info_pt &&
    !form.tax_info_it
  )
}

export const projectFormSectionHelpers = {
  isCertificationsCompleted,
  isContentCompelted,
  isDefinitionCompleted,
  isDocumentationCompleted,
  isLocationCompleted,
  isTaxReliefCompleted,
  isPriceCompleted
}
